<template>
  <div class="order-shipping-forwarder">
    <v-list
      two-line
      min-width="100%"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            {{ localValue.shipping.address.address.title }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ localValue.shipping.address.address.address }}
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn
            icon
            small
          >
            <v-icon small>
              mdi-pencil
            </v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-divider />

    <v-radio-group v-model="localValue.shipping.forwarder.forwarder">
      <template v-for="(forwarder, j) in forwarders">
        <v-row :key="j">
          <v-col cols="1" class="d-flex">
            <v-radio
              class="align-self-center"
              :value="forwarder"
            />
          </v-col>
          <v-col>
            <v-list min-width="100%">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ forwarder.text }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn
                    icon
                    small
                  >
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </template>

      <v-row>
        <v-col offset="1">
          <v-list>
            <v-list-item-action>
              <v-btn
                color="primary"
                text
              >
                <v-icon left>
                  mdi-plus
                </v-icon>
                New Forwarder
              </v-btn>
            </v-list-item-action>
          </v-list>
        </v-col>
      </v-row>
    </v-radio-group>
  </div>
</template>

<script>
import ModelableMixin from '../../../../mixins/modelable';

export default {
  name: 'Forwarder',

  mixins: [
    ModelableMixin,
  ],

  computed: {
    forwarders() {
      return [
        { text: 'Hook Fast Forwarder' },
        { text: 'Billboarn Marion Forwarder' },
      ];
    },
  },
};
</script>

<style scoped>

</style>
